/*
 * Copyright '2025' Dell Inc. or its subsidiaries. All Rights Reserved.
 */
export const LOCALE_PROVIDER_MAX_PRIORITY = 999999;
export const DEFAULT_LOCALE_PROVIDER_PRIORITIES: Record<string, number> = {
  LWP_COOKIE: LOCALE_PROVIDER_MAX_PRIORITY,
  LOCAL_STORAGE: LOCALE_PROVIDER_MAX_PRIORITY - 1000,
  BROWSER_LANGUAGE: LOCALE_PROVIDER_MAX_PRIORITY - 2000,
};
